{
    "webshop_offer_voucher_correctCode": "Cod corect introdus",
    "webShop_howToFindId_desc": "Poți găsi și copia ID-ul personal din profilul tău de jucător.",
    "webShop_howToFindId_link": "Unde găsesc ID-ul meu personal?",
    "webshop_offer_voucher_codeIsIncorrect": "Codul este incorect",
    "webshop_offer_voucher_enterYourCode": "Introdu ID-ul personal",
    "webShop_unexpectedError_desc": "A apărut o eroare neașteptată, încearcă din nou mai târziu.",
    "webShop_accountBanned_desc": "Cont blocat!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Termeni și Condiții",
    "webshop_purchase_privacyPolicy": "Politica de confidenţialitate",
    "webshop_legal_1": "Juridic",
    "webshop_support_1": "Asistenţă",
    "mbs_access_welcome_desc": "Bun venit, {0}",
    "btn_login": "Conectare",
    "mbs_access_error_sessionExpired_desc": "Sesiunea ta a expirat. Introdu manual ID-ul contului."
}
